import React, { Component } from 'react';
import styles from './CreateMaterial.module.css';
import ImportForm from '../../components/ImportForm';
import JsonForm from '../../components/JsonForm';
import Divider from '../../components/Divider';
import CheckGroup from '../../components/CheckGroup';
import Modal from '../../components/Modal';
import { connect } from 'react-redux';
import {
  createMaterial,
  getMaterial,
  saveMaterial,
} from '../../modules/materials';
import { getTags, createTag } from '../../modules/tags';
import { getOrganization } from '../../modules/users';
import PropTypes from 'prop-types';

class CreateMaterial extends Component {
  state = {
    formData: { metadata: {} },
    metadata: {},
    modalOpen: false,
    schema: [
      {
        key: 'metadata.Season',
        label: 'Season Code (Ex. S19, F19)',
        length: '10%',
        required: true,
      },
      {
        key: 'metadata.Launch_Date',
        label: 'Launch Date',
        length: '20%',
        required: true,
      },
      {
        key: 'metadata.Material_Code',
        label: 'Material Code',
        length: '10%',
        required: true,
      },
      {
        key: 'metadata.File_Name',
        label: 'Material Reference Filename',
        length: '50%',
        required: true,
      },
      {
        key: 'friendlyName',
        label: 'Material Name',
        length: '50%',
        required: true,
      },
      {
        key: 'metadata.Vendor_Code',
        label: 'Vendor Code',
        length: '10%',
        required: false,
      },
      {
        key: 'state',
        label: 'State',
        select: true,
        options: [
          { label: 'Active', value: 'Active' },
          { label: 'Discontinued', value: 'Discontinued' },
          { label: 'Canceled', value: 'Canceled' },
        ],
      },
      {
        key: 'metadata.Pattern',
        label: 'Pattern / Solid',
        select: true,
        options: [
          { label: 'Pattern', value: 'Pattern' },
          { label: 'Solid', value: 'Solid' },
        ],
      },
      {
        key: 'metadata.Application',
        label: 'Application',
        select: true,
        options: [
          { label: 'Railroad', value: 'Railroad' },
          { label: 'Up the Bolt', value: 'Up the Bolt' },
        ],
      },
      {
        key: 'metadata.Lighting',
        label: 'Material Value for Lighting (L,M,D)',
        select: true,
        options: [
          { label: 'L', value: 'L' },
          { label: 'M', value: 'M' },
          { label: 'D', value: 'D' },
        ],
      },
      {
        key: 'metadata.Non-LR_Symmetric',
        label: 'Non-LR Symmetric?',
        checkBox: true,
        default: false,
      },
      {
        key: 'metadata.Suede',
        label: 'Is material suede?',
        checkBox: true,
        default: false,
      },
      {
        key: 'metadata.RepeatX',
        label: 'Horizontal Fabric Repeat (centimeters)',
        length: '10%',
        required: false,
      },
      {
        key: 'metadata.RepeatY',
        label: 'Vertical Fabric Repeat (centimeters)',
        length: '10%',
        required: false,
      },
      { key: 'thumbnail', label: 'Thumbnail URL' },
      // { key: 'reviewers', label: 'Reviewers', required: true },
    ],
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  async componentDidMount() {
    const { router } = this.context;
    const { id } = router.route.match.params;
    if (id) {
      const { catogary, getMaterial } = this.props;
      if (catogary === 'materials') {
        const material = await getMaterial(id);
        this.setState({ formData: material, metadata: material.metadata });
      }
    }
  }

  createOrUpdateEntity = () => {
    const { router } = this.context;
    const { formData, schema, metadata } = this.state;
    const { catogary, createMaterial, type, saveMaterial } = this.props;
    for (let i in schema) {
      if (
        schema[i].required &&
        (!formData[schema[i].key] || formData[schema[i].key].length === 0)
      ) {
        this.setState({ error: `${schema[i].label} is required ` });
        return;
      }
      if (schema[i].key.indexOf('metadata') !== -1) {
        const key = schema[i].key;
        const newKey = key.replace(/metadata\./g, '').replace(/\_/g, ' ');
        metadata[newKey] = formData[key];
        delete formData[key];
      }
    }
    this.setState({ error: null });
    for (const i in metadata) {
      if (!metadata[i]) delete metadata[i];
    }
    formData.metadata = metadata;
    const newFormData = Object.assign({}, formData);
    for (let i in newFormData) {
      if (/metadata\./gi.test(i)) delete newFormData[i];
    }
    if (type === 'new') {
      if (catogary === 'materials') {
        createMaterial(newFormData).then(e => {
          router.history.push('/');
        });
      }
    } else if (type === 'edit') {
      const { id } = router.route.match.params;
      if (catogary === 'materials') {
        saveMaterial(id, newFormData).then(e =>
          router.history.push(`/materials/${id}`)
        );
      }
    }
  };

  onChange = (key, value) => {
    const { formData } = this.state;
    if (key.indexOf('metadata') !== -1) {
      const newKey = key.replace(/metadata\./g, '').replace(/\_/g, ' ');
      formData['metadata'][newKey] = value;
      delete formData[key];
    } else {
      formData[key] = value;
    }
    this.setState({ formData });
  };

  onMetadataChange = data => {
    const metadata = data.reduce((acc, v) => {
      acc[v.label] = v.value;
      return acc;
    }, {});
    this.setState({ metadata });
  };

  toggleTagModal = open => {
    this.setState({ modalOpen: open });
  };

  render() {
    const { catogary, type, tags, organization, createTag } = this.props;
    const { formData, schema, error, metadata, modalOpen } = this.state;
    const checkOptions = tags ? tags.map(tag => tag[0]) : [];
    // client maybe add reviewers bakc in the furture
    // const organizationOptions =
    //   organization &&
    //   organization.members.map(member => {
    //     const { username } = member;
    //     return { label: username, value: username };
    //   });
    return (
      <div className={styles.newModel}>
        <div className={styles.header}>
          {type === 'new' ? 'New' : 'Edit'}{' '}
          {catogary[0].toUpperCase() + catogary.slice(1, -1)} Information
          <Divider />
        </div>

        <div className={styles.inputBlick}>
          {' '}
          <ImportForm
            schema={schema}
            catogary={catogary}
            formData={formData}
            onChange={this.onChange}
            tags={tags}
          />
          <div className={styles.checkBoxContainer}>
            <CheckGroup
              title="Tags"
              options={checkOptions}
              onChange={this.onChange}
              selectedOptions={formData['tags']}
              keyLetter="tags"
              creatNew
              toggleModal={this.toggleTagModal}
            />
          </div>
          {/* client maybe add reviewers bakc in the furture */}
          {/* <CheckGroup
            title="Reviewers"
            options={organizationOptions}
            onChange={this.onChange}
            keyLetter="reviewers"
            selectedOptions={formData['reviewers']}
            required
          /> */}
        </div>
        <JsonForm onChange={this.onMetadataChange} metadata={metadata} />
        <Modal
          open={modalOpen}
          title="Create New Tag"
          createTag={createTag}
          closeModal={e => this.toggleTagModal(false)}
        />
        {error && <div className={styles.errorText}>{error} </div>}
        <button
          className={styles.saveButton}
          onClick={this.createOrUpdateEntity}
        >
          {type === 'new' ? 'Create' : 'Update'}
        </button>
      </div>
    );
  }
}

const createMaterialPage = (catogary, type) => {
  return connect(
    state => ({
      catogary,
      type,
      tags: getTags(state),
      organization: getOrganization(state),
    }),
    {
      createMaterial,
      getMaterial,
      saveMaterial,
      createTag,
    }
  )(CreateMaterial);
};

export default createMaterialPage;



// WEBPACK FOOTER //
// ./src/containers/CreateMaterial/index.js